import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { companyReportApi } from 'services/apiDigitalTicket/company';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as CompanyReportActions from './actions';
import { CompanyReportTypes, ImportationsReportTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof CompanyReportActions.listCompanyReportRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando empresas' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyReportApi.list, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        CompanyReportActions.listCompanyReportSuccess({
          companyReportList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company - companyReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyReportActions.listCompanyReportFaliure());
    yield put(DialogsActions.setClose());
  }
}

function* importaionsReport({
  payload,
}: ReturnType<typeof CompanyReportActions.importaionsReportRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Carregando Importações' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyReportApi.importations, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        CompanyReportActions.importaionsReportSuccess({
          importationsReport: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company - companyReport - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyReportActions.importaionsReportFaliure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const companyReportSagas = [
  takeLatest(CompanyReportTypes.LIST_COMPANY_REPORT_REQUEST, list),
  takeLatest(
    ImportationsReportTypes.IMPORTATIONS_REPORT_REQUEST,
    importaionsReport,
  ),
];
